import React from 'react'
import { Link } from 'react-router-dom'

function DailyMeals() {
  return (
    <>
      {/* Inner Banner Section */}
      <section className="inner-banner">
        <div
          className="image-layer"
          style={{ backgroundImage: "url(assets/images/coimbatore-homemade-food-banner.jpg)" }}
        ></div>
        <div className="auto-container">
          <div className="inner">
            <h1>Daily Meals</h1>
            <div className="sub_text">
              <p>
                Home - <a href="" className="primary-color">Daily Meals</a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="story-section section-kt">
        <div className="auto-container">
          <div className="title-box centered">
            <div className="subtitle"><span>Tickling Tummy</span></div>
            <h2>
              <span className="theme_color">Daily Meals</span> — Pure Veg Homemade Pre‑Order & Pickup in Coimbatore
            </h2>
          </div>
          <div className="row clearfix">
            <div className="text-col col-xl-12 col-lg-12 col-md-12 col-sm-12 text-center">
              <p>
                Feeling tired or too busy to cook? Wondering what to eat without repeating yesterday's meal?
                Let Tickling Tummy take the stress off your plate. Our Daily Meals are the perfect solution
                for anyone looking for fresh, home-cooked, vegetarian food that’s comforting, nutritious,
                and satisfying.<br /><br />

                Every day, we prepare a rotating menu of traditional and seasonal dishes, carefully cooked
                in small batches—just like at home. All you need to do is pre-order your meal, and we’ll
                have it packed and ready for pickup.<br /><br />

                Based in R.S. Puram, we serve working professionals, seniors, and home-food lovers across
                Coimbatore—covering Avinashi Road, Ganpathy, Gandhi Park, Gandhipuram, Koundampalayam,
                Ponyarajpuram, Race Course, Ram Nagar, Saibaba Colony, Saravanampatti, Sulur, Thudiyalur,
                Trichy Road, Vadavalli and more.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section - Image Left, Content Right */}
      <section className="fluid-section chef-bio">
        <div className="outer-container">
          <div className="row clearfix">

            {/* Image Left */}
            <div className="image-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="inner wow fadeInLeft">
                <div
                  className="image-layer"
                  style={{ backgroundImage: "url(assets/images/daily-meals-subscription-cover.jpg)" }}
                ></div>
                <div className="image">
                  <img src="assets/images/daily-meals-subscription-cover.jpg" alt="homemade food delivery Saibaba Colony" />
                </div>
              </div>
            </div>

            {/* Content Right */}
            <div className="content-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="inner clearfix wow fadeInRight">
                <div className="content-box">
                  <div className="chef-thumb">
                    <img src="assets/images/meals-subscription-thumbnail.jpg" alt="homemade food delivery Tatabad" />
                  </div>

                  {/* What's on the Daily Special Menu */}
                  <div className="title-box">
                    <div className="subtitle"><span>What’s on the Daily Special Menu?</span></div>
                    <div className="text">
                      <ul>
                        <li>◆ South Indian combos: variety rice, meals, tiffin</li>
                        <li>◆ North Indian meals: Phulkas, sabji, dal rice, biryani</li>
                        <li>◆ Modern mixes: Pasta, stir-fried veggies, millet bowls, salads</li>
                      </ul>
                      <p>Follow us on Instagram (@tickling.tummy) to see today’s menu in stories!</p>
                    </div>
                  </div>

                  {/* Why Choose Our Daily Meals */}
                  <div className="title-box centered">
                    <div className="subtitle"><span>Why Choose Our Daily Meals?</span></div>
                    <div className="text">
                      <ul>
                        <li>◆ Pure vegetarian & homemade – crafted with love, hygiene, and no preservatives</li>
                        <li>◆ Healthy & balanced – meals designed for energy, nutrition, and taste</li>
                        <li>◆ Convenient pre-order & pickup – no waiting, no stress</li>
                        <li>◆ Flexible choices daily – variety that beats boredom</li>
                      </ul>
                    </div>
                  </div>

                  {/* How It Works */}
                  <div className="title-box centered">
                    <div className="subtitle"><span>How It Works</span></div>
                    <div className="text">
                      <ul>
                        <li>◆ Browse our daily menu – updated daily a day before</li>
                        <li>◆ Pre-order via WhatsApp (insert whatsapp link)</li>
                        <li>◆ Pick up at R.S. Puram – your food will be freshly packed</li>
                        <li>◆ Enjoy the homemade goodness!</li>
                      </ul>
                    </div>
                  </div>

                  {/* Ideal For */}
                  <div className="title-box centered">
                    <div className="subtitle"><span>Ideal For</span></div>
                    <div className="text">
                      <ul>
                        <li>◆ Working professionals without time to cook</li>
                        <li>◆ Seniors who crave clean, simple food</li>
                        <li>◆ Conscious vegetarians</li>
                        <li>◆ Families and students wanting budget-friendly meals</li>
                      </ul>
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* FAQ Schema for Daily Meals */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "Is the food truly homemade?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, every meal at Tickling Tummy is cooked in our home kitchen in R.S. Puram, Coimbatore, using fresh ingredients and traditional recipes."
              }
            },
            {
              "@type": "Question",
              "name": "Can I customize my daily meal subscription?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Absolutely! We cater to specific dietary needs like low salt, low oil, or no onion/garlic options for our regular subscribers."
              }
            },
            {
              "@type": "Question",
              "name": "How is the food packed for delivery?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We use high-quality, food-grade, leak-proof packaging to ensure your meal stays warm and fresh during transit."
              }
            }
          ]
        })}
      </script>
    </>

  )
}

export default DailyMeals
